import React from 'react';
import Link from 'atomic/utilization/link';

import './footer.base.scss';
import Container from 'atomic/utilization/container';

const getCurrentYear = (): number => new Date().getFullYear();

const Footer: React.FC = ({ children }) => (
    <footer className="footer">
        {children}
        <Container>
            <div className="footer__bar">
                <ul>
                    <li>
                        <Link href="/site/doc/9" title="Reklama" rel="nofollow">
                            Reklama
                        </Link>
                    </li>
                    <li>
                        <Link href="/SiteMap" title="Mapa strony Skąpiec.pl">
                            Mapa strony
                        </Link>
                    </li>
                    <li>
                        <Link href="https://polityka-prywatnosci.onet.pl/" title="Polityka prywatności w Skąpiec.pl" rel="nofollow">
                            Polityka prywatności
                        </Link>
                    </li>
                    <li>
                        <Link href="/obowiazek-informacyjny" title="Obowiązek informacyjny" rel="nofollow">
                            Obowiązek informacyjny
                        </Link>
                    </li>
                    <li>
                        <Link href="/kontakt?t=1" title="Przejdź do strony kontaktu" rel="nofollow">
                            Zgłoś uwagi
                        </Link>
                    </li>
                </ul>
                <strong>
                    © Skapiec.pl
                    {' '}
                    <span>
                        2004-
                        {getCurrentYear()}
                    </span>
                </strong>
            </div>
        </Container>
    </footer>
);

export default Footer;
